module.exports = __webpack_public_path__ + "static/media/pentagram_diagonal_5_1.e233a00b.png";